// @storybook-skip: internal section of LessonExploreCard; covered by its card story
import { setOpacity } from "@memorang/helpers/setOpacity";
import { Image } from "expo-image";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import { CircularProgressBar } from "../ProgressBar/Circular";
import type { LessonProgressStatus } from "./types";

const THUMBNAIL_OVERLAY_OPACITY = 0.68;

type Props = {
	thumbnailUrl: string;
	status: LessonProgressStatus;
	progressPercent: number;
	size?: number;
};

export const LessonExploreThumbnail = ({
	thumbnailUrl,
	status,
	progressPercent,
	size = 72,
}: Props) => {
	const theme = useAppTheme();
	const isCompleted = status === "completed";
	const showsOverlay = status !== "notStarted";
	const progress = isCompleted
		? 1
		: Math.min(Math.max(progressPercent, 0), 100) / 100;

	return (
		<Box
			width={size}
			height={size}
			borderRadius={theme.roundness * 3}
			overflow="hidden"
			flexShrink={0}
		>
			<Image
				source={thumbnailUrl}
				contentFit="cover"
				style={{
					width: size,
					height: size,
					backgroundColor: theme.colors.elevation.level3,
				}}
			/>
			{showsOverlay ? (
				<>
					<Box
						position="absolute"
						top={0}
						left={0}
						right={0}
						bottom={0}
						backgroundColor={theme.colors.primary}
						style={{ opacity: THUMBNAIL_OVERLAY_OPACITY }}
					/>
					<Box
						position="absolute"
						top={0}
						left={0}
						right={0}
						bottom={0}
						alignItems="center"
						justifyContent="center"
					>
						<CircularProgressBar
							size="medium"
							progress={progress}
							progressColor={
								isCompleted
									? theme.palette.success.light
									: theme.colors.onPrimary
							}
							trackColor={setOpacity(theme.colors.onPrimary, 0.3)}
						/>
						{isCompleted ? (
							<Box
								position="absolute"
								top={0}
								left={0}
								right={0}
								bottom={0}
								alignItems="center"
								justifyContent="center"
							>
								<AppIcon
									name="check"
									size={20}
									color={theme.palette.success.light}
								/>
							</Box>
						) : null}
					</Box>
				</>
			) : null}
		</Box>
	);
};
